import { render, staticRenderFns } from "./wizardTrainingAssesment.vue?vue&type=template&id=28cd9d02&scoped=true"
import script from "./wizardTrainingAssesment.vue?vue&type=script&lang=js"
export * from "./wizardTrainingAssesment.vue?vue&type=script&lang=js"
import style0 from "./wizardTrainingAssesment.vue?vue&type=style&index=0&id=28cd9d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd9d02",
  null
  
)

export default component.exports